import React, { useContext, useEffect, useState } from "react";
import "./Product_add_to_cart_card.css";
import { Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { AddToCartLuxury } from "../../../utils/luxuryapis/addToCart/addToCart";
import View_cart_modal from "../view_cart_modal/View_cart_modal";
import {
  addWishlist,
  getWishlist,
} from "../../../utils/luxuryapis/Wishlist/Wishlist";
import { Context } from "../../../utils/context";

function Product_add_to_cart_card({
  image,
  product,
  url,
  title,
  mrp,
  selling_price,
  discount,
  id,
  getDataWishlists,
}) {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const {
    shimmerLoader,
    setShimmerLoader,
    wishlistData,
    wishlistContext,
    signin,
  } = useContext(Context);

  const [isWishlisted, setIsWishlisted] = useState([]);
  const [togle, setTogle] = useState([]);
  const handleHeartClick = async (data) => {
    if (signin) {
      const res = await addWishlist(data);
      if (res?.success) {
        setTogle(!togle);
        getWishlists();
      }
    } else {
      navigate("/login");
    }
  };

  const getWishlists = async () => {
    try {
      const res = await getWishlist();
      const wishlist = res?.data;
      setIsWishlisted(wishlist);
      if (getDataWishlists) {
        getDataWishlists();
      }
    } catch (error) {
      console.error("Failed to fetch wishlist:", error);
    }
  };

  // useEffect(() => {
  //   getWishlists();
  // }, [product?.id, togle]);
  return (
    <section className="Product_add_to_cart_card">
      <Card className="product_card">
        {/* Image Section */}
        <div className="product_img_wrapper">
          <Link to={url}>
            <Card.Img variant="top" src={image} className="product_img" />
          </Link>

          <button
            className="wishlist_btn"
            onClick={() =>
              handleHeartClick({
                product_id: product?.id,
                variant_id: product?.product_variants[0]?.id,
              })
            }
          >
            <FontAwesomeIcon
              icon={
                isWishlisted?.some((item) => item.product_id === product?.id)
                  ? faHeartSolid
                  : faHeartRegular
              }
            />
          </button>
        </div>

        {/* Content */}
        <Card.Body className="product_body">
          <h6 className="product_title">{title}</h6>

          <div className="mrp_row">
            <span className="mrp_label">MRP:</span>
            <span className="mrp_value">₹{mrp}</span>
          </div>

          <div className="price_discount_row">
            <div className="selling_price">
              <span className="selling_label">Selling Price:</span>
              <span className="selling_value">₹ {selling_price}</span>
            </div>

            {discount && (
              <div className="discount_text">{discount}% Discount</div>
            )}
          </div>

          {/* Buttons */}
          <div className="btn_row">
            <Button
              className="details_btn"
              variant="outline-secondary"
              onClick={() => navigate(url)}
            >
              Details
            </Button>
          </div>
        </Card.Body>
      </Card>

      <View_cart_modal
        show={show}
        handleClose={() => setShow(false)}
        handleViewCart={() => alert("Go to cart page")}
      />
    </section>
  );
}

export default Product_add_to_cart_card;
